"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLogKinds = void 0;
// NOTE: This is how we want to do enums across the entire code base!
// TODO make all the other weird enum stuff look like this
exports.EventLogKinds = {
    // e.g. discussion on an event
    Chat: "chat",
    // e.g. generic created event, updated event, deleted event
    Activity: "activity",
    // e.g. person A invited persons B and C
    Invite: "invite",
};
//# sourceMappingURL=EventLog.js.map